var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8799 18.94L16.4099 13.4C16.7799 13.03 16.9899 12.52 16.9899 11.99V2C16.9899 0.9 16.0899 0 14.9899 0H5.9999C5.1999 0 4.4799 0.48 4.1699 1.21L0.9099 8.82C0.0598996 10.8 1.5099 13 3.6599 13H9.3099L8.3599 17.58C8.2599 18.08 8.4099 18.59 8.7699 18.95C9.3599 19.53 10.2999 19.53 10.8799 18.94ZM20.9999 0C19.8999 0 18.9999 0.9 18.9999 2V10C18.9999 11.1 19.8999 12 20.9999 12C22.0999 12 22.9999 11.1 22.9999 10V2C22.9999 0.9 22.0999 0 20.9999 0Z",
    fill: "#E26C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardType2);
export default __webpack_public_path__ + "static/media/card_type_2.7341cb0952c3aa0645448aaba7b3bd45.svg";
export { ForwardRef as ReactComponent };